import { useEffect, useState } from 'react'
import { api } from '../api.js'

const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']

export default function RendezVous({ onOuvrir }) {
  const [liste, setListe] = useState([])

  const charger = () => api.bookings().then(setListe)
  useEffect(() => { charger() }, [])   // eslint-disable-line

  const parJour = liste.reduce((acc, b) => {
    (acc[b.day] ||= []).push(b)
    return acc
  }, {})

  return (
    <>
      <h1>Rendez-vous</h1>
      <p className="chapo">Les créneaux réservés depuis le portail, sur les trois prochaines semaines.</p>

      {Object.keys(parJour).length ? Object.entries(parJour).map(([jour, rdvs]) => {
        const d = new Date(jour + 'T12:00:00')
        return (
          <section className="carte" key={jour}>
            <h2 className="jour-titre">
              {JOURS[d.getDay()]} {d.getDate()} {d.toLocaleDateString('fr-FR', { month: 'long' })}
            </h2>
            <table className="tableau">
              <thead><tr><th>Heure</th><th>Qui</th><th>Téléphone</th><th>Permanence</th><th /></tr></thead>
              <tbody>
                {rdvs.map((b) => (
                  <tr key={b.id}>
                    <td className="mono">{b.time}</td>
                    <td><strong>{b.name}</strong></td>
                    <td className="mono">{b.phone || '-'}</td>
                    <td>{b.agenda}</td>
                    <td className="actions-cellule">
                      {b.request_id && (
                        <button className="btn sm" onClick={() => onOuvrir(b.request_id)}>Dossier</button>
                      )}
                      <button className="btn sm dgr" onClick={async () => {
                        if (!confirm(`Libérer le créneau de ${b.name} ?`)) return
                        await api.cancelBooking(b.id); charger()
                      }}>Libérer</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )
      }) : (
        <div className="carte vide">
          <h2>Aucun rendez-vous</h2>
          <p>Les créneaux réservés par les habitants apparaîtront ici.</p>
        </div>
      )}
    </>
  )
}
